
import { Autocomplete, Box, Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as yup from 'yup';

const ProductMapping = ({ onSubmit, onCancel, closedStatus, outletId, outletName, selectedOutletName }) => {
    const [outletData, setOutletData] = useState([]);
    const [outletData1, setOutletData1] = useState([]);
    const [outletToData, setOutletToData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);

    const dispatch = useDispatch();
    
    const validationSchema = yup.object({
        // fromoutlet: yup.object().required("From Outlet is required"),
        tooutlet: yup.object().required("Outlet is required"),
    });

    const formik = useFormik({
        initialValues: {
            fromoutlet: null,
            tooutlet: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            const cloneData = {
                from_outlet: 0,
                // from_outlet: values.fromoutlet?.outlet_id,
                to_outlet: values.tooutlet?.id,
            };

            setIsLoader(true);
            try {
                await axios.post('/v1/outlet/to/outlet/transfer', cloneData);
                dispatch(setSnackbar(true, 'success', 'Product Assigned Successfully!'));
                setIsLoader(false);
                
                // Reset form values to clear previous selections
                formik.resetForm();

                // Optional callback after success
                if (onSubmit) onSubmit(); 
                
                // Close modal
                onCancel(false);

                // Refetch the outlet data to update the modal content
                getOutletData();
                // window.location.reload();
            } catch (err) {
                const errorMessage = err.response?.data?.errors?.[0]?.message || 'An error occurred';
                dispatch(setSnackbar(true, 'error', errorMessage));
                setIsLoader(false);
            }
        },
    });

    const getOutletData = () => {
        setIsLoader(true);
        axios.get('/v1/outlet/list/1')
            .then(res => {
                setOutletData(res.data);
                setIsLoader(false);
            })
            .catch(err => {
                dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
                setIsLoader(false);
            });
    };

    const getfromOutletData = () => {
        setIsLoader(true);
        axios.get('/v1/outlet/to/outlet/transfer/existing')
            .then(res => {
                setOutletData1(res.data);
                setIsLoader(false);
            })
            .catch(err => {
                dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
                setIsLoader(false);
            });
    };
    
    const gettoOutletData = () => {
        setIsLoader(true);
        axios.get('/v1/outlet/to/outlet/transfer/new')
            .then(res => {
                setOutletToData(res.data);
                setIsLoader(false);
            })
            .catch(err => {
                setIsLoader(false);
            });
    };
    const handleCancel = () => {
        formik.resetForm();
        onCancel(false); // Close modal
        // getfromOutletData();
        // gettoOutletData();
        // getOutletData();
        
        // window.location.reload();
    };


    const filteredOutletData = outletData1.filter(outlet => outlet.fullname === selectedOutletName);
    // useEffect(() => {
    //     // Set the default value for fromoutlet once filteredOutletData is available
    //     if (filteredOutletData.length > 0 && !formik.values.fromoutlet) {
    //         const defaultValue = filteredOutletData[0]; // Choose the first item as the default
    //         formik.setFieldValue("fromoutlet", defaultValue);
    //     }
    // }, [filteredOutletData,formik]); // Run this effect when filteredOutletData updates
    useEffect(() => {
        getfromOutletData();
        gettoOutletData();
        getOutletData();
    }, [dispatch]);
    return (
        <Grid className="bg-white p-5">
            <Typography variant="h5">Select Outlet to Assign Product?</Typography>

            {/* <Grid item xs={12} md={4} lg={3}>
                <Box display="flex" alignItems="center" mb={0.8}>
                    <Typography variant="body1" fontSize={17}>From Outlet</Typography>
                </Box>
                <Autocomplete
                    id="fromoutlet"
                    size="small"
                    options={filteredOutletData}
                    getOptionLabel={(option) => option.fullname}
                    value={formik.values.fromoutlet}
                    onChange={(e, value) => formik.setFieldValue("fromoutlet", value)}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select From Outlet"
                            error={formik.touched.fromoutlet && Boolean(formik.errors.fromoutlet)}
                            helperText={formik.touched.fromoutlet && formik.errors.fromoutlet}
                        />
                    )}
                />
            </Grid> */}

            <Grid item xs={12} md={4} lg={3}>
                <Box display="flex" alignItems="center" mb={0.8}>
                    <Typography variant="body1" fontSize={17}>Assign Outlet</Typography>
                </Box>
                <Autocomplete
                    id="tooutlet"
                    size="small"
                    options={outletToData}
                    getOptionLabel={(option) => option.fullname}
                    value={formik.values.tooutlet}
                    onChange={(e, value) => formik.setFieldValue("tooutlet", value)}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select Outlet"
                            error={formik.touched.tooutlet && Boolean(formik.errors.tooutlet)}
                            helperText={formik.touched.tooutlet && formik.errors.tooutlet}
                        />
                    )}
                />
            </Grid>

            <Grid className="flex justify-center mt-5">
                <Button variant="outlined"
                //  onClick={() => onCancel(false)}
                 onClick={handleCancel}
                 >Cancel</Button>
                <Button
                    variant="contained"
                    sx={{ marginInline: 2, backgroundColor: 'green !important' }}
                    onClick={formik.handleSubmit}
                    disabled={isLoader} // Disable button during loading
                >
                    {isLoader ? "Cloning..." : "Save"}
                </Button>
            </Grid>
        </Grid>
    );
};

export default ProductMapping;


